import script from "./BuyerAutocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyerAutocomplete.vue?vue&type=script&setup=true&lang=ts"

import "./BuyerAutocomplete.vue?vue&type=style&index=0&id=5f9e6eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f9e6eba"]])

export default __exports__